import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/TransitionGroupContext.js
// module id = 758
// module chunks = 2